import React from 'react';
import { locales } from '../../../translations/locales';
import { FaChevronRight } from 'react-icons/fa6';

const ResumeQualification = (props) => {
    const { locale, onChangeQualification, category, qualification } = props;

    return (
        <div className='row'>
            <div className='col-12'>
                <span
                    className='alert alert-success cursor-pointer p-1 m-1'
                    onClick={() => onChangeQualification({ target: { id: 'qualification', value: '' } })}
                >
                    {locales[locale].sga[category]}
                    <FaChevronRight className='mb-1' />
                    {qualification}
                </span>
            </div>
        </div>
    );
};

export default ResumeQualification;
